<template>
  <form @submit.prevent="submit">
    <v-row justify="space-between">
      <v-col cols="12" sm="10" md="6">
        <DateSelector
          v-if="loaded"
          label="Datum"
          :date="form.endDate"
          :dateDisabled="dateDisabled"
          disabled
          @change="updateEndDate"
        />
        <v-text-field
          v-if="articles && articles.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @input="$emit('update-filter', filter)"
          @keydown.esc="filter=''"
        ></v-text-field>
        <v-btn
          v-if="showLoadingBtn"
          :disabled="disableLoadingBtn"
          @click="getCurrentStockData"
          color="#0F998E"
          class="white--text"
        >
          Pridobi
          <v-icon right dark>{{!inventory ? 'fas fa-search' : 'mdi-content-save-outline'}}</v-icon>
        </v-btn>
        <v-select
          v-if="!inventory"
          v-model="form.selectedCategoryIds"
          :items="categories"
          :menu-props="{ maxHeight: '400' }"
          label="Skupine"
          multiple
          hint="Izberite željene skupine ali pustite prazno za vse skupine"
          persistent-hint
          item-text="name"
          item-value="id"
          clearable
        ></v-select>
        <v-textarea
            v-else
            ref="textareacomment"
            v-model="localComment"
            label="Komentar"
        />
        <v-select
          v-if="!inventory"
          :items="currentStockOptions"
          item-text="name"
          item-value="val"
          v-model="form.currentStockOption"
          label="Trenutna zaloga"
        ></v-select>
      </v-col>
      <v-col cols="12" md="auto">
          <v-row>
            <v-col cols="12">
              <v-btn
                v-if="!inventory"
                type="submit"
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
              >
                {{!inventory ? 'Prikaži' : 'Shrani'}}
                <v-icon right dark>{{!inventory ? 'fas fa-search' : 'mdi-content-save-outline'}}</v-icon>
              </v-btn>
            </v-col>
            <!-- <v-col>
              <v-btn
                v-show="inventory"
                color="#0F998E"
                class="white--text ml-3 float-right d-inlineblock"
                @click="goback"
              >
                Prekliči
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row
            v-if="!inventory"
            >
            <v-col cols="12" class="py-0">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print(1)"
              >
                Tiskaj osnovno
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="!inventory"
            >
            <v-col cols="12" class="py-0">
              <v-btn
                color="#0F998E"
                class="white--text mt-2 float-right d-inlineblock"
                @click="print(2)"
              >
                Tiskaj podrobno
              </v-btn>
            </v-col>
          </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import DateSelector from './DateSelector'
import { objectToArray } from '@/utils/object'

export default {
  props: ['inventory','inventoryData','unsaved','showLoadingBtn','disableLoadingBtn','dateDisabled','articles'],
  components: {
    DateSelector
  },
  data () {
    return {
      filter: '',
      form: {
        endDate: '',
        selectedCategoryIds: [],
        comment: '',
        currentStockOption: null
      },
      currentStockOptions: [
        {
          name: 'Trenutna zaloga',
          val: 0
        },
        {
          name: 'Zaloga z upoštevanjem odprtih naročil',
          val: 1
        },
        {
          name: 'Zaloga na odprtih naročilih',
          val: 2
        }
      ],
      categories: [],
      loaded: false,
      localComment: ''
    }
  },
  computed: {
    newComment () {
      return this.localComment
    }
  },
  methods: {
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    getCurrentStockData () {
      this.$emit('getCurrentStockData')
    },
    goback () {
      this.$router.replace({ name: 'MyCompanyInventoryForms' })
    },
    returnInventoryForm () {
      return { ...this.form, comment: this.localComment }
    },
    submit () {
      this.form = {
        ...this.form,
        comment: this.localComment
      }
      this.$emit('submit', this.form)
    },
    print (type) {
      this.form = {
        ...this.form,
        comment: this.localComment
      }
      const form = { ...this.form }
      form.reportType = type
      this.$emit('print', form)
    },
    clearForm () {
      this.form = {
        endDate: moment().format('YYYY-MM-DD'),
        selectedCategoryIds: []
      }
    },
    updateEndDate ({ date }) {
      this.form.endDate = date
      this.$emit('change', date)
    }
  },
  created () {
    this.loaded = false
    this.clearForm()
    // const inventureName = 'INVENTURA'
    if (!this.inventory) {
      this.loadCategories()
        .then(response => {
          this.categories = objectToArray(this.$store.state.categories.items)
          if (this.inventory && this.inventoryData) {
            this.form.comment = this.inventoryData.comment
            this.localComment = this.form.comment
            this.form.endDate = moment(this.inventoryData.date).format('YYYY-MM-DD')
          }/*  else if (this.inventory && !this.inventoryData) {
            this.form.comment = inventureName
            this.$refs.textareacomment.value = inventureName
          } */
          this.loaded = true
          this.submit()
        })
    } else {
      this.loaded = true
      if (this.inventory && this.inventoryData) {
        this.form.comment = this.inventoryData.comment
        this.localComment = this.form.comment
        this.form.endDate = moment(this.inventoryData.date).format('YYYY-MM-DD')
        // this.$emit('change', this.form.date)
      }
      this.submit()
    }
  },
  watch: {
    newComment (val, prevVal) {
      if (val && (val !== prevVal)) {
        this.unsaved = true
        this.$emit('change')
      }
    }
  }
}
</script>
